module.exports = __webpack_public_path__ + "img/canvasMenuLine.192462dc.svg";